import { Controller } from '@hotwired/stimulus';
import { showNotification } from '@components/notification_box/component_controller';

export default class extends Controller {
  static targets = ['failureMessages'];
  static values = {
    newsletterSubscriptionId: Number,
  };

  connect() {
    this.element.addEventListener(
      'ajax:success',
      this.updateSuccesful.bind(this)
    );
    this.element.addEventListener('ajax:error', this.updateFailure.bind(this));

    this.failureMessagesTarget.hidden = true;
  }

  updateSuccesful(event) {
    this.failureMessagesTarget.hidden = true;

    const [data] = event.detail;
    if (data.status == 'ok') {
      const message = data.messages.join('. ');
      showNotification(message, { timeoutInMs: 3500 });
    }
  }

  updateFailure(event) {
    const [data] = event.detail;
    let failureMessage = '';
    if (data.error_messages) {
      failureMessage = data.error_messages.join('\n<br/>');
    } else {
      failureMessage =
        'Da ist etwas schiefgegangen. Kontaktiere unseren Support.';
    }
    this.failureMessagesTarget.hidden = false;
    this.failureMessagesTarget.innerHTML = failureMessage;
  }
}
